/*
 * 機能名：日計表出力
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdSubHeader from '@/components/DdSubHeader'

import filter from '@/rahmen/utils/filters'
import flowMixin from '@/mixins/flowMixins'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import message from '@/ddv2.library/messages'
import modals from '@/ddv2.library/modals'
import validators from '@/rahmen/validators'
import { mapGetters } from 'vuex'

export default {
  name: 'NikkeihyoOutput',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdCodeTextBox,
    DdDateBox,
    DdRadioButton,
    DdSubHeader
  },
  data: () => ({
    isConditionHide: false,
    isCsvDownloader: false,
    isXlsDownloader: false,
    conditions: {
      shutsuryokuStartYmdString: '',
      shutsuryokuEndYmdString: '',
      eigyoshoId: null,
      targetDataNo: '99'
    },
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    dispNikkeihyoCsvNm: '',
    dispNikkeihyoExcelNm: '',
    modeKengen: 0
  }),
  computed: {
    // --------------------------------------------------------------------------------
    // Indexed DB データ
    // --------------------------------------------------------------------------------
    ...mapGetters({
      currentKaishaCode: 'users/currentKaishaCode',
      eigyoshoList: 'DDMasters/mstEigyosho',
      usersEigyosho: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    eigyoshoReadOnly () {
      const self = this
      return !self.eigyoshoLockFlg
    },
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho'],
        initializeInputPromise: (c) => {
          self.initBindVariables()
        },
        savedInputRestorePromise: (c) => {
          console.log('D2BZMD0020.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('D2BZMD0020.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        restoreViewPromise: (c) => {
          console.log('D2BZMD0020.restoreViewPromise', c)
          return new Promise(resolve => {
            this.conditions = c.cache.value.conditions || {}
            this.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initBindVariables()
      })
      this.Effects.loadComplete()
    },
    onCsvButtonClick: function (e) {
      if (!this.outputValidate) { return }
      this.isCsvDownloader = true
      console.log(e)
      let apiController = null
      if (this.conditions.targetDataNo !== '2') {
        this.dispNikkeihyoCsvNm = this.conditions.targetDataNo === '99' ? `日計表(全ての受注)_${this.getTimeStamp()}.csv` : `日計表(配車計画済み)_${this.getTimeStamp()}.csv`
        apiController = '/api/v1/vwCD2bzmd0021/Download'
      } else {
        this.dispNikkeihyoCsvNm = `日計表(実績)_${this.getTimeStamp()}.csv`
        apiController = '/api/v1/vwCD2bzmd0020/Download'
      }
      const self = this
      // todo:レポート出力
      this.HttpClient
        .requestFileByPost(apiController, this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const bom = new Uint8Array([0xef, 0xbb, 0xbf])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('csvDownload')
          self.isCsvDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          apiController = undefined
          modals.showToastMessage('COMI0007', null, 800, null, 'info')
        })
    },
    onExcelButtonClick: function (e) {
      this.clearSummaryMessage()
      if (!this.outputValidate) { return }
      this.isXlsDownloader = true
      console.log(e)
      let apiController = null
      if (this.conditions.targetDataNo !== '2') {
        this.dispNikkeihyoExcelNm = this.conditions.targetDataNo === '99' ? `日計表(全ての受注)_${this.getTimeStamp()}.xlsm` : `日計表(配車計画済み)_${this.getTimeStamp()}.xlsm`
        apiController = '/api/v1/vwCD2bzmd0021/ExcelOutput'
      } else {
        this.dispNikkeihyoExcelNm = `日計表(実績)_${this.getTimeStamp()}.xlsm`
        apiController = '/api/v1/vwCD2bzmd0020/ExcelOutput'
      }
      // todo:レポート出力
      const self = this
      this.HttpClient
        .requestFileByPost(apiController, this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const blob = new Blob([data], { type: 'application/vnd.ms-excel.sheet.macroEnabled.12' })
          const elem = document.getElementById('excelDownload')
          self.isXlsDownloader = false
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
          modals.showToastMessage('COMI0007', null, 800, null, 'info')
        })
    },
    initBindVariables: function () {
      const today = filter.dateFormatter(new Date())
      this.conditions = {
        shutsuryokuStartYmdString: filter.dateFormatter(new Date()),
        shutsuryokuEndYmdString: filter.dateFormatter(new Date()),
        eigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyosho, today).id : null,
        targetDataNo: '99'
      }
    },
    outputValidate: function () {
      if (this.conditions.shutsuryokuStartYmdString && this.conditions.shutsuryokuEndYmdString) {
        var msg = validators.compareYearMonth(this.conditions.shutsuryokuStartYmdString, this.conditions.shutsuryokuEndYmdString)
        if (msg !== undefined) {
          this.$refs.shutsuryokuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.shutsuryokuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      } else if (!this.conditions.shutsuryokuStartYmdString) {
        this.$refs.shutsuryokuStartYmdString[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      } else if (!this.conditions.shutsuryokuEndYmdString) {
        this.$refs.shutsuryokuEndYmdString[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return false
      }
      return true
    },
    getTimeStamp () {
      var date = new Date()
      const Y = date.getFullYear()
      const M = ('00' + (date.getMonth() + 1)).slice(-2)
      const D = ('00' + date.getDate()).slice(-2)
      const h = ('00' + date.getHours()).slice(-2)
      const m = ('00' + date.getMinutes()).slice(-2)
      const s = ('00' + date.getSeconds()).slice(-2)

      return Y + M + D + h + m + s
    }
  }
}
